export const MONITOR_SERVER_METRIC = 'MONITOR_SERVER_METRIC';
